<div class="unavailable-page">
  <ng-leaf-icon-next
    class="cg-hide-for-print cg-margin-left-sm"
    name="error"
    category="system"
    weight="regular"
    size="100"
  ></ng-leaf-icon-next>
  <h3>Currently unavailable</h3>
  <p>
    We apologize for the inconvenience. Please revisit the site at a later time.
  </p>
  <button
    *ngIf="shouldShowRefreshBtn"
    (click)="refreshBrowser()"
    cignaButton="primary"
  >
    Retry
  </button>
</div>
